export default __webpack_public_path__ + "static/media/logo_campus_black.2c40e1c3.png";